import { render, staticRenderFns } from "./q-privacy.vue?vue&type=template&id=bf704f68&"
import script from "./q-privacy.vue?vue&type=script&lang=js&"
export * from "./q-privacy.vue?vue&type=script&lang=js&"
import style0 from "./q-privacy.vue?vue&type=style&index=0&id=bf704f68&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yangxinyuan/vhall/vhall_questionnaire_service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf704f68')) {
      api.createRecord('bf704f68', component.options)
    } else {
      api.reload('bf704f68', component.options)
    }
    module.hot.accept("./q-privacy.vue?vue&type=template&id=bf704f68&", function () {
      api.rerender('bf704f68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/q-privacy.vue"
export default component.exports